import { render, staticRenderFns } from "./AuthFinish.vue?vue&type=template&id=99304478&scoped=true&"
import script from "./AuthFinish.vue?vue&type=script&lang=js&"
export * from "./AuthFinish.vue?vue&type=script&lang=js&"
import style0 from "./AuthFinish.vue?vue&type=style&index=0&id=99304478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99304478",
  null
  
)

export default component.exports